import {
  ODataHeader,
  ODataString,
  ODataInteger,
  ODataDecimal,
} from "pbas-vue-components";
import { translate2 } from "../trans2";
const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});

function getHeaders() {
  return [
    new ODataHeader({
      type: new ODataString("PlanId"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
      isIdentifier: true,
    }),
    new ODataHeader({
      type: new ODataString("Plan/PlanId"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "globals.plan",
      type: new ODataString("Plan/Number"),
      sortable: true,
      visible: true,
      searchable: true,
      orderByKey: "Name",
    }),
    new ODataHeader({
      title: "headers.claims_settings.client_id",
      type: new ODataString("ClientID"),
      visible: true,
      allowVisibilityChange: true,
      searchable: true,
      sortable: true,
    }),
    new ODataHeader({
      title: "headers.claims_settings.payee_match_number",
      type: new ODataString("PayeeMatchNumber"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.members_management.Institution Number",
      type: new ODataString("InstitutionNumber"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.members_management.Transit Number",
      type: new ODataString("TransitNumber"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.members_management.Account Number",
      type: new ODataString("AccountNumber"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.claims_settings.srf_number",
      type: new ODataString("SrfNumber"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      type: new ODataString("BankShortName"),
      searchable: false,
      visible: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("CompanyShortName"),
      searchable: false,
      visible: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("CompanyLongName"),
      searchable: false,
      visible: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "headers.claims_settings.audit_percentage",
      type: new ODataInteger("AuditPercentage", {
        getString: (item) => {
          if (
            item.AuditPercentage !== null &&
            item.AuditPercentage !== undefined
          ) {
            return `${item.AuditPercentage}%`;
          }
          return "";
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    // new ODataHeader({
    //   title: "headers.claims_settings.dispensing_fee_cap",
    //   type: new ODataDecimal("DispensingFeeCap",{
    //     getString: (item, type) => {
    //       const value = item.DispensingFeeCap;
    //       if (value === null || value === undefined) {
    //         return "";
    //       }
    //       if (typeof value !== "number") {
    //         return value;
    //       }
    //       return formatter.format(value);
    //     },
    //   }),
    //   sortable: true,
    //   visible: true,
    //   searchable: true,
    // }),
    new ODataHeader({
      type: new ODataString("EOBPlanName"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      type: new ODataString("EOBPlanEmail"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      type: new ODataString("EOBPlanPhone"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      type: new ODataString("EOBPlanAddress"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      type: new ODataString("BankShortName"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      type: new ODataString("ClaimAdminId"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("ClaimAdmin/Name"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "components.claims_settings.claim_admin",
      type: new ODataString("ClaimAdmin/Translations[]/Name", {
        getString: (item) => translate2(item.ClaimAdmin, "Name"),
      }),
      sortable: false,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      type: new ODataString("ClaimAdmin/Translations[]/LanguageCode"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      type: new ODataString("UnderwriterId"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("Underwriter/Name"),
      sortable: true,
      visible: false,
      searchable: false,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "components.claims_settings.underwriter",
      type: new ODataString("Underwriter/Translations[]/Name", {
        getString: (item) => translate2(item.Underwriter, "Name"),
      }),
      sortable: false,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      type: new ODataString("Underwriter/Translations[]/LanguageCode"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      type: new ODataString("ChequePrefix"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      type: new ODataString("DirectDepositPrefix"),
      sortable: false,
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
  ];
}

export default getHeaders;
